import {api} from './api'
import {ApiResponse, DashboardStats} from '../types'

export const getDashboardStats = async (): Promise<DashboardStats | null> => {
    try {
        const response = await api.get<ApiResponse<DashboardStats>>('/api/admin/stats/advanced')
        console.log('📊 Dashboard Stats Response:', response.data)
        return response.data.data || null
    } catch (error) {
        console.error('Error fetching dashboard stats:', error)
        return null
    }
}

export const getStatsByDate = async (startDate: string, endDate: string): Promise<any> => {
    try {
        const response = await api.get(`/api/admin/stats/range?start=${startDate}&end=${endDate}`)
        return response.data.data
    } catch (error) {
        console.error('Error fetching stats by date:', error)
        return null
    }
}